import React, { forwardRef, useEffect, useRef, useState } from 'react';

import ptBR from 'date-fns/locale/pt-BR';
import InputMask from 'react-input-mask';
import DatePicker from 'react-datepicker';
import { DataFilter, DialogContent, DialogOptions, Input } from './styles';
import { Icon } from 'react-materialize';
import api from '../../../services/api';
import { format } from 'date-fns';
import { getFromStorage } from '../../../services/auth';
import WaitScreen from '../../../Components/Globals/WaitScreen';
import { alerta } from '../../../services/funcoes';

const CustomCalendarInput = forwardRef(({ value, onClick, onChange }, ref) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      width: '130px',
      justifyContent: 'space-around',
      borderBottom: '1px solid #ccc',
      zIndex: '50 !important',
    }}
  >
    <InputMask
      style={{ width: '100px', zIndex: '50 !important' }}
      mask="99/99/9999"
      value={value}
      maskChar={null}
      onChange={onChange}
    />
    <span onClick={onClick} style={{ cursor: 'pointer', color: 'rgb(97, 9, 138)' }}>
      <Icon>date_range</Icon>
    </span>
  </div>
));

export function DialogHistoryWebHook({ onClose }) {
  const [startDate, setStartDate] = useState(new Date());
  const [listLogsWebHook, setListLogsWebHook] = useState([]);
  const [itemSelected, setItemSelected] = useState(null);
  const [loading, setLoading] = useState(false);

  async function handleHistoricWebhook(date) {
    try {
      const parseDate = format(date, 'dd/MM/yyyy');
      setLoading(true);
      const sessao = getFromStorage();

      const empresaAtiva = sessao.empresaId;
      const usuarioAtivo = sessao.codigoUsuario;

      const res = await api.get(
        `v1/trade/admin/sales/webhook/response/${empresaAtiva}/${usuarioAtivo}?data=${parseDate}`
      );

      const { sucess, data } = res.data;

      if (sucess) {
        const sortedData = data.sort((a, b) => new Date(a.GWE_DTA_CADASTRO) - new Date(b.GWE_DTA_CADASTRO));
        setListLogsWebHook(sortedData);
      }
    } catch (error) {
      alerta('Erro ao buscar dados');
    } finally {
      setStartDate(date);
      setLoading(false);
    }
  }
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    handleHistoricWebhook(new Date());
    hasRun.current = true;
  }, []);

  return (
    <>
      <WaitScreen loading={loading} />
      <DialogOptions>
        <DialogContent>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <button
              onClick={onClose}
              style={{
                border: 'none',
                padding: '0.5rem',
                borderRadius: '100%',
                color: '#FFF',
                background: '#8e44ad',
                fontSize: '1.1rem',
                width: '40px',
                height: '40px',
              }}
            >
              X
            </button>
          </div>
          <DataFilter style={{ flexWrap: 'wrap', marginTop: '-10px' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label style={{ paddingLeft: '10px', color: '#000', fontSize: '0.9rem' }}>Selecione uma data</label>
              <DatePicker
                id="startDate"
                selected={startDate}
                onChange={(e) => handleHistoricWebhook(e)}
                locale={ptBR}
                placeholderText="Data"
                dateFormat="dd/MM/yyyy"
                selectsStart
                startDate={startDate}
                customInput={<CustomCalendarInput />}
              />
            </div>
          </DataFilter>
          <h2 style={{ margin: '0', fontSize: '1.2rem' }}>
            Histórico de logs do dia {format(startDate, 'dd/MM/yyyy')}
          </h2>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              overflowY: 'auto',
              gap: '0.5rem',
              height: '240px',
            }}
          >
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                border: '1px solid #8e44ad',
              }}
            >
              <thead>
                <tr style={{ background: '#8e44ad' }}>
                  <th
                    style={{
                      border: '1px solid #d1d5db',
                      padding: '0.5rem 1rem',
                      textAlign: 'center',
                      color: '#fff',
                    }}
                  >
                    Data/Hora
                  </th>
                  <th
                    style={{
                      border: '1px solid #d1d5db',
                      padding: '0.5rem 1rem',
                      textAlign: 'center',
                      color: '#fff',
                    }}
                  >
                    URL
                  </th>
                  <th
                    style={{
                      border: '1px solid #d1d5db',
                      padding: '0.5rem 1rem',
                      textAlign: 'center',
                      color: '#fff',
                    }}
                  >
                    Logs
                  </th>
                </tr>
              </thead>
              <tbody>
                {listLogsWebHook &&
                  listLogsWebHook.length > 0 &&
                  listLogsWebHook.map((item) => (
                    <tr
                      key={item.url}
                      style={{
                        transition: 'background-color 0.2s ease-in-out',
                      }}
                    >
                      <td
                        style={{
                          border: '1px solid #d1d5db',
                          padding: '0.5rem 1rem',
                          textAlign: 'center',
                        }}
                      >
                        {format(new Date(item.GWE_DTA_CADASTRO), 'dd/MM/yyyy hh:mm:ss')}
                      </td>
                      <td
                        style={{
                          border: '1px solid #d1d5db',
                          padding: '0.5rem 1rem',
                          textAlign: 'center',
                          userSelect: 'all',
                        }}
                      >
                        <a
                          href={item.GWE_URL}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: '#2563eb', textDecoration: 'underline', cursor: 'pointer' }}
                        >
                          {item.GWE_URL}
                        </a>
                      </td>
                      <td
                        style={{
                          border: '1px solid #d1d5db',
                          padding: '0.5rem 1rem',
                          textAlign: 'center',
                        }}
                      >
                        <button
                        title='Ver'
                          style={{
                            backgroundColor: '#8e44ad',
                            color: 'white',
                            padding: '0.25rem 0.75rem',
                            borderRadius: '0.375rem',
                            cursor: 'pointer',
                            border: 'none',
                            transition: 'background-color 0.2s ease-in-out',
                          }}
                          onClick={() => setItemSelected(item)}
                        >
                          <Icon>visibility</Icon>
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>

            {(!listLogsWebHook || listLogsWebHook.length === 0) && <span>Sem dados para o dia selecionado</span>}
          </div>
          {itemSelected && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                overflowY: 'auto',
                gap: '0.5rem',
                height: '200px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  gap: '0.2rem',
                  flexDirection: 'column',
                  border: '1px solid #8e44ad',
                  borderRadius: '6px',
                }}
              >
                <div
                  style={{
                    background: '#8e44ad',
                    borderRadius: '6px',
                    padding: '0.3rem',
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                  }}
                >
                  <span style={{ color: '#fff' }}>
                    <strong>Data de cadastro:</strong>{' '}
                    {format(new Date(itemSelected.GWE_DTA_CADASTRO), 'dd/MM/yyyy hh:mm:ss')}
                  </span>
                  <button
                    style={{
                      backgroundColor: 'transparent',
                      border: 'none',
                      fontSize: '16px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '22px',
                      height: '22px',
                      color: "#fff"
                    }}
                    onClick={() => setItemSelected(null)}
                  >
                    X
                  </button>
                </div>
                <div
                  style={{
                    display: 'flex',
                    gap: '0.2rem',
                    flexDirection: 'column',
                    padding: '0.3rem',
                  }}
                >
                  <span>
                    <strong>Payload:</strong> {itemSelected.GWE_PAYLOAD}
                  </span>
                  <span>
                    <strong>Resposta curta</strong>
                  </span>
                  <Input type="text" value={itemSelected.GWE_RESPONSE_TEXTO} />
                  <span>
                    <strong>Resposta longa</strong>
                  </span>
                  <Input type="text" value={itemSelected.GWE_RESPONSE_COMP} />
                </div>
              </div>
            </div>
          )}
        </DialogContent>
      </DialogOptions>
    </>
  );
}
